﻿(function ($, d, ns) {
  ns.initCustomFileUploadFileName = function () {
    $('.itr-file-upload .file-input-container input[type=file]').change(function () {
      var file = $('.file-input-container input[type=file]')[0].files[0].name;
      $('.itr-file-upload .file-input-button--filename').text(file);
      $('.itr-file-upload .file-input-button--filename').show(); 
    });
  };

  $(d).ready(function () {
    ns.initCustomFileUploadFileName();
  });


})(jQuery, document, Crafted.Utilities);